module.exports = __webpack_public_path__ + "static/media/pic-tb1.1156fc14.jpg";